import { createFileRoute } from "@tanstack/react-router";
import AdminServersPage from "@/admin/pages/servers";

export const Route = createFileRoute("/admin/servers")({
  component: AdminServersPage,
});
